// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkSelectorUpload-cls1_q6G","cls2":"WorkSelectorUpload-cls2_F4W WorkSelectorUpload-cls1_q6G"};